const curTheme = 'light'

const palette = {
    black: '#333333',
    gray: '#8A8A8A',
    transparentGray: 'rgba(50, 50, 50, 0.3)',
    transparentWhite: 'rgba(255, 255, 255, 0.3)',
    white: '#ffffff',
    liteBlue: '#85b1c7',
    darkBlue: '#607d8b',
    orange: '#ff5722',
    red: '#d53402',
    // ---- new 8/21/2019
    blue: "#106AC5",
    accentGradientLeft: '#09A182',
    accentGradientRight: '#01848F'
}

const themes = {
    light: {
        backgroundColor: palette.white,
        text: palette.black,
        subduedText: palette.gray,
        inverseText: palette.white,
        shadow: palette.transparentGray,
        action: palette.accentGradientRight,
        dividers: palette.gray,
        coloredHeaders: palette.accentGradientRight,
    },
}

export const breakpoints =  {
    large: 1200,
    medium: 900,
    small: 630,
    buffer: 40,
}

export const lessThanLargeGutter = 40;

export const headerHeight = { default: 116, small: 60 }
export const theme = themes[curTheme]



// WEBPACK FOOTER //
// ./src/ui-config.js